import { Button, Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IVideoError } from '../utils/errors.utils';

interface IProps {
  error: IVideoError | null;
  onRetry: () => void;
}

export const Error:React.FC<IProps> = ({ error, onRetry }) => {
  const { t } = useTranslation();
  return (
    <div className="myinterview-widget-error">
      <Text size="H3-Regular" className="myinterview-widget-error__message">{error?.errorMessage || ''}</Text>
      <Button onClick={onRetry}>{t('buttons.btn_retry')}</Button>
    </div>
  );
};
